var _excluded = ["label", "className", "size", "svgAttrs"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { forwardRef, tqc } from '../../../system';
import { cx } from '../../../utils';
import { useThemedValueSwitch } from '../../hooks';
var SpinnerSvg = function SpinnerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, "@keyframes e9gIli2PB4q2_to__to", "{", "0%", "{", "transform:translate(0px,0px);animation-timing-function:cubic-bezier(1,-0.01,0.305,0.82)", "}", "16.666667%", "{", "transform:translate(32px,19px);animation-timing-function:cubic-bezier(1,-0.01,0.135,0.9)", "}", "39.666667%", "{", "transform:translate(0px,0px)", "}", "100%", "{", "transform:translate(0px,0px)", "}", "}", "@keyframes e9gIli2PB4q7__m", "{", "0%", "{", "d:path('M266.569347,222.19557C266.569347,222.19557,266.245089,0.058361,266.245089,0.058361C266.245089,0.058361,22.838685,137.172708,22.838685,137.172708C22.838685,137.172708,22.85116,363.703624,22.85116,363.703624L266.569347,222.19557Z');animation-timing-function:cubic-bezier(0.995,0.01,0.225,0.905)", "}", "16.666667%", "{", "d:path('M19.885902,357.858444C19.885902,357.858444,19.561644,135.721235,19.561644,135.721235C19.561644,135.721235,-223.84476,272.835582,-223.84476,272.835582C-223.84476,272.835582,-223.368367,499.693834,-223.368367,499.693834L19.885902,357.858444Z');animation-timing-function:cubic-bezier(0.965,0.26,0.83,0.96)", "}", "33.333333%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,23.055869,134.296896,23.055869,134.296896C23.055869,134.296896,23.532262,361.155148,23.532262,361.155148L266.786531,219.319758Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "43.333333%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,268.10976,-1.357532,268.10976,-1.357532C268.10976,-1.357532,267.837332,222.614121,267.837332,222.614121L266.786531,219.319758Z')", "}", "100%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,268.10976,-1.357532,268.10976,-1.357532C268.10976,-1.357532,267.837332,222.614121,267.837332,222.614121L266.786531,219.319758Z')", "}", "}", "@keyframes e9gIli2PB4q11__m", "{", "0%", "{", "d:path('M17.567151,356.147799C17.567151,356.147799,19.295819,129.866026,19.295819,129.866026C19.295819,129.866026,-223.868626,270.263928,-223.868626,270.263928C-223.868626,270.263928,-222.244447,501.425858,-222.244447,501.425858L17.567151,356.147799Z')", "}", "60%", "{", "d:path('M17.567151,356.147799C17.567151,356.147799,19.295819,129.866026,19.295819,129.866026C19.295819,129.866026,-223.868626,270.263928,-223.868626,270.263928C-223.868626,270.263928,-222.244447,501.425858,-222.244447,501.425858L17.567151,356.147799Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "70%", "{", "d:path('M273.140857,206.744138C273.140857,206.744138,273.140857,-8.776087,273.140857,-8.776087C273.140857,-8.776087,13.998065,137.118709,13.998065,137.118709C13.998065,137.118709,16.365978,353.745453,16.365978,353.745453L273.140857,206.744138Z')", "}", "100%", "{", "d:path('M273.140857,206.744138C273.140857,206.744138,273.140857,-8.776087,273.140857,-8.776087C273.140857,-8.776087,13.998065,137.118709,13.998065,137.118709C13.998065,137.118709,16.365978,353.745453,16.365978,353.745453L273.140857,206.744138Z')", "}", "}", "@keyframes e9gIli2PB4q15__m", "{", "0%", "{", "d:path('M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,181.430125,248.01397,181.430125,248.01397C181.430125,248.01397,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z')", "}", "50%", "{", "d:path('M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,181.430125,248.01397,181.430125,248.01397C181.430125,248.01397,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "63.333333%", "{", "d:path('M195.607543,443.417191C195.607543,443.417191,196.339477,245.048833,196.339477,245.048833C196.339477,245.048833,18.801817,249.148581,18.801817,249.148581C18.801817,249.148581,18.378116,446.906193,18.378116,446.906193L195.607543,443.417191Z')", "}", "76.666667%", "{", "d:path('M21.541188,441.528971C21.541188,441.528971,20.275959,242.571759,20.275959,242.571759C20.275959,242.571759,16.990065,247.506287,16.990065,247.506287C16.990065,247.506287,18.316032,445.847123,18.316032,445.847123L21.541188,441.528971Z')", "}", "100%", "{", "d:path('M21.541188,441.528971C21.541188,441.528971,20.275959,242.571759,20.275959,242.571759C20.275959,242.571759,16.990065,247.506287,16.990065,247.506287C16.990065,247.506287,18.316032,445.847123,18.316032,445.847123L21.541188,441.528971Z')", "}", "}", "@keyframes e9gIli2PB4q20_to__to", "{", "0%", "{", "transform:translate(511.125179px,509.794124px);animation-timing-function:cubic-bezier(1,-0.01,0.305,0.82)", "}", "16.666667%", "{", "transform:translate(478.125179px,480.794124px);animation-timing-function:cubic-bezier(1,-0.01,0.135,0.9)", "}", "39.666667%", "{", "transform:translate(511.125179px,509.794124px)", "}", "100%", "{", "transform:translate(511.125179px,509.794124px)", "}", "}", "@keyframes e9gIli2PB4q25__m", "{", "0%", "{", "d:path('M19.885902,357.858444C19.885902,357.858444,19.561644,135.721235,19.561644,135.721235C19.561644,135.721235,-223.84476,272.835582,-223.84476,272.835582C-223.84476,272.835582,-223.368367,499.693834,-223.368367,499.693834L19.885902,357.858444Z')", "}", "40%", "{", "d:path('M19.885902,357.858444C19.885902,357.858444,19.561644,135.721235,19.561644,135.721235C19.561644,135.721235,-223.84476,272.835582,-223.84476,272.835582C-223.84476,272.835582,-223.368367,499.693834,-223.368367,499.693834L19.885902,357.858444Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "53.333333%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,23.055869,134.296896,23.055869,134.296896C23.055869,134.296896,23.532262,361.155148,23.532262,361.155148L266.786531,219.319758Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "66.666667%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,268.10976,-1.357532,268.10976,-1.357532C268.10976,-1.357532,267.837332,222.614121,267.837332,222.614121L266.786531,219.319758Z')", "}", "100%", "{", "d:path('M266.786531,219.319758C266.786531,219.319758,266.462273,-2.817451,266.462273,-2.817451C266.462273,-2.817451,268.10976,-1.357532,268.10976,-1.357532C268.10976,-1.357532,267.837332,222.614121,267.837332,222.614121L266.786531,219.319758Z')", "}", "}", "@keyframes e9gIli2PB4q29__m", "{", "0%", "{", "d:path('M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,180.90085,253.523335,180.90085,253.523335C180.90085,253.523335,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z')", "}", "33.333333%", "{", "d:path('M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,180.90085,253.523335,180.90085,253.523335C180.90085,253.523335,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "46.666667%", "{", "d:path('M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,18.65148,253.523335,18.65148,253.523335C18.65148,253.523335,18.54149,445.699727,18.54149,445.699727L196.165123,443.649825Z');animation-timing-function:cubic-bezier(1,-0.025,0.665,0.895)", "}", "56.666667%", "{", "d:path('M20.381989,445.809135C20.381989,445.809135,21.809012,247.954236,21.809012,247.954236C21.809012,247.954236,18.65148,253.523335,18.65148,253.523335C18.65148,253.523335,18.54149,445.699727,18.54149,445.699727L20.381989,445.809135Z')", "}", "100%", "{", "d:path('M20.381989,445.809135C20.381989,445.809135,21.809012,247.954236,21.809012,247.954236C21.809012,247.954236,18.65148,253.523335,18.65148,253.523335C18.65148,253.523335,18.54149,445.699727,18.54149,445.699727L20.381989,445.809135Z')", "}", "}"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9gIli2PB4q17-fill",
    x1: "-0.000024",
    y1: "0.499972",
    x2: "1.000048",
    y2: "0.499972",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q17-fill-0",
    offset: "0%",
    stopColor: "rgba(0,0,0,0.0908818)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q17-fill-1",
    offset: "48.970171%",
    stopColor: "rgba(16,90,158,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q17-fill-2",
    offset: "100%",
    stopColor: "rgba(0,0,0,0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9gIli2PB4q31-fill",
    x1: "-0.000024",
    y1: "0.499972",
    x2: "1.000048",
    y2: "0.499972",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q31-fill-0",
    offset: "0%",
    stopColor: "rgba(0,0,0,0.0908818)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q31-fill-1",
    offset: "48.970171%",
    stopColor: "rgba(16,90,158,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e9gIli2PB4q31-fill-2",
    offset: "100%",
    stopColor: "rgba(0,0,0,0.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)",
    style: {
      animation: "e9gIli2PB4q2_to__to 1000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q2",
    transform: "translate(0,0)",
    clipPath: "url(#e9gIli2PB4q18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q3",
    d: "M266.051274,0.299852L266.051277,206.09095L179.4312,255.85862L179.42733,440.24606L22.95501,346.04024L22.95501,137.02646L266.051274,0.299852Z",
    fill: "rgb(16,90,158)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q4",
    mask: "url(#e9gIli2PB4q6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q5",
    d: "M216.696641,188.306656C216.696641,188.306656,218.791977,-21.948751,218.791977,-21.948751C218.791977,-21.948751,-31.96212,118.614814,-31.96212,118.614814C-31.96212,118.614814,-35.273969,333.262748,-35.273969,333.262748L216.696641,188.306656Z",
    transform: "matrix(1 0 0 1 50.775729 16.924732)",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1.024"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9gIli2PB4q6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.569347,222.19557C266.569347,222.19557,266.245089,0.058361,266.245089,0.058361C266.245089,0.058361,22.838685,137.172708,22.838685,137.172708C22.838685,137.172708,22.85116,363.703624,22.85116,363.703624L266.569347,222.19557Z",
    transform: "matrix(1 0 0 1 0.000004 0.000002)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: "0",
    style: {
      animation: "e9gIli2PB4q7__m 1000ms linear infinite normal forwards"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q8",
    mask: "url(#e9gIli2PB4q10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q9",
    d: "M215.763488,188.771084C215.763488,188.771084,218.791977,-21.948751,218.791977,-21.948751C218.791977,-21.948751,-31.96212,118.614814,-31.96212,118.614814C-31.96212,118.614814,-36.046741,333.863045,-36.046741,333.863045L215.763488,188.771084Z",
    transform: "matrix(1 0 0 1 50.775729 16.924732)",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1.024"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9gIli2PB4q10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.567151,356.147799C17.567151,356.147799,19.295819,129.866026,19.295819,129.866026C19.295819,129.866026,-223.868626,270.263928,-223.868626,270.263928C-223.868626,270.263928,-222.244447,501.425858,-222.244447,501.425858L17.567151,356.147799Z",
    transform: "matrix(1 0 0 1 0.000004 0.000002)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: "0",
    style: {
      animation: "e9gIli2PB4q11__m 1000ms linear infinite normal forwards"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q12",
    mask: "url(#e9gIli2PB4q14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q13",
    d: "M134.114938,428.774997C134.114938,428.774997,137.189791,233.891861,137.189791,233.891861C137.189791,233.891861,-32.719529,331.928321,-32.719529,331.928321C-32.719529,331.928321,128.990184,427.750046,128.990184,427.750046L134.114938,428.774997Z",
    transform: "matrix(1 0 0 1 50.775729 16.924732)",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1.024"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9gIli2PB4q14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,181.430125,248.01397,181.430125,248.01397C181.430125,248.01397,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z",
    transform: "matrix(1 0 0 1 0.000004 0.000002)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: "0",
    style: {
      animation: "e9gIli2PB4q15__m 1000ms linear infinite normal forwards"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "e9gIli2PB4q16",
    points: "120.582204,45.621022 42.552335,0.516423 40.698941,91.830275",
    transform: "matrix(1.001013 -1.733805 1.733805 1.001013 -20.673461 419.20958)",
    opacity: "0.2",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e9gIli2PB4q17",
    points: "-0.122878,216.2535 0,114.718381 118.640498,46.35744 118.725707,147.548879",
    transform: "matrix(2.056001 0 0 2.056002 22.970402 -98.736057)",
    fill: "url(#e9gIli2PB4q17-fill)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9gIli2PB4q18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q19",
    d: "M265.913658,0.314901L266.051277,205.09095L179.4312,255.85862L179.42733,440.24606L22.95501,346.04024L22.95501,137.02646L265.913658,0.314901Z",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(511.125179,509.794124)",
    style: {
      animation: "e9gIli2PB4q20_to__to 1000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q20",
    transform: "rotate(180) translate(0,0)",
    clipPath: "url(#e9gIli2PB4q32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q21",
    d: "M266.051274,0.299852L266.051277,206.09095L179.4312,255.85862L179.42733,440.24606L22.95501,346.04024L22.95501,137.02646L266.051274,0.299852Z",
    fill: "rgb(16,90,158)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q22",
    mask: "url(#e9gIli2PB4q24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q23",
    d: "M216.696641,187.306656C216.696641,187.306656,218.791977,-21.948751,218.791977,-21.948751C218.791977,-21.948751,-31.96212,118.614814,-31.96212,118.614814C-31.96212,118.614814,-35.690668,334.389528,-35.690668,334.389528L216.696641,187.306656Z",
    transform: "matrix(1 0 0 1 50.775729 16.924732)",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1.024"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9gIli2PB4q24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.885902,357.858444C19.885902,357.858444,19.561644,135.721235,19.561644,135.721235C19.561644,135.721235,-223.84476,272.835582,-223.84476,272.835582C-223.84476,272.835582,-223.368367,499.693834,-223.368367,499.693834L19.885902,357.858444Z",
    transform: "matrix(1 0 0 1 0.000004 0.000002)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: "0",
    style: {
      animation: "e9gIli2PB4q25__m 1000ms linear infinite normal forwards"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e9gIli2PB4q26",
    mask: "url(#e9gIli2PB4q28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q27",
    d: "M134.114938,428.774997C134.114938,428.774997,137.189791,234.034328,137.189791,234.034328C137.189791,234.034328,-32.87158,331.433051,-32.87158,331.433051C-32.87158,331.433051,128.990184,427.750046,128.990184,427.750046L134.114938,428.774997Z",
    transform: "matrix(1 0 0 1 50.775729 16.924732)",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1.024"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9gIli2PB4q28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.165123,443.649825C196.165123,443.649825,196.831353,245.381491,196.831353,245.381491C196.831353,245.381491,180.90085,253.523335,180.90085,253.523335C180.90085,253.523335,180.79086,445.699727,180.79086,445.699727L196.165123,443.649825Z",
    transform: "matrix(1 0 0 1 0.000004 0.000002)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: "0",
    style: {
      animation: "e9gIli2PB4q29__m 1000ms linear infinite normal forwards"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "e9gIli2PB4q30",
    points: "120.582204,45.621022 42.676219,0.536438 40.698941,91.830275",
    transform: "matrix(1.001013 -1.733805 1.733805 1.001013 -20.673461 419.20958)",
    opacity: "0.2",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e9gIli2PB4q31",
    points: "0,215.999618 0,114.718381 118.640498,46.35744 118.725707,147.548879",
    transform: "matrix(2.056001 0 0 2.056002 23.171272 -98.736057)",
    fill: "url(#e9gIli2PB4q31-fill)",
    stroke: "none",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9gIli2PB4q32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e9gIli2PB4q33",
    d: "M266.051274,-0.700148L266.051277,205.09095L179.4312,255.85862L179.42733,440.24606L22.95501,346.04024L22.95501,137.02646L266.051274,-0.700148Z",
    fill: "rgb(72,166,61)",
    stroke: "none",
    strokeWidth: "1"
  })))));
};
SpinnerSvg.defaultProps = {
  id: "e9gIli2PB4q1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
};
var NISpinnerSvg = function NISpinnerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, "@keyframes ezBt1kfOUiw2__rd", "{", "0%", "{", "rx:8px;ry:8px", "}", "21.875%", "{", "rx:40px;ry:40px", "}", "46.875%", "{", "rx:8px;ry:8px", "}", "71.875%", "{", "rx:40px;ry:40px", "}", "100%", "{", "rx:8px;ry:8px", "}", "}", "@keyframes ezBt1kfOUiw2_f_p", "{", "0%", "{", "fill:#060e2c", "}", "21.875%", "{", "fill:#05487a", "}", "46.875%", "{", "fill:#060e2c", "}", "71.875%", "{", "fill:#05487a", "}", "100%", "{", "fill:#060e2c", "}", "}", "@keyframes ezBt1kfOUiw2_tr__tr", "{", "0%", "{", "transform:translate(75.064516px,75.064516px) rotate(0deg)", "}", "21.875%", "{", "transform:translate(75.064516px,75.064516px) rotate(44.999999deg)", "}", "46.875%", "{", "transform:translate(75.064516px,75.064516px) rotate(89.999999deg)", "}", "71.875%", "{", "transform:translate(75.064516px,75.064516px) rotate(135deg)", "}", "100%", "{", "transform:translate(75.064516px,75.064516px) rotate(180deg)", "}", "}", "@keyframes ezBt1kfOUiw3_c_o", "{", "0%", "{", "opacity:1", "}", "21.875%", "{", "opacity:0", "}", "46.875%", "{", "opacity:1", "}", "71.875%", "{", "opacity:0", "}", "100%", "{", "opacity:1", "}", "}", "@keyframes ezBt1kfOUiw8_c_o", "{", "0%", "{", "opacity:0", "}", "21.875%", "{", "opacity:1", "}", "46.875%", "{", "opacity:0", "}", "71.875%", "{", "opacity:1", "}", "100%", "{", "opacity:0", "}", "}", ">"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.064516,75.064516) rotate(0)",
    style: {
      animation: "ezBt1kfOUiw2_tr__tr 3200ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "110",
    height: "110",
    rx: "8",
    ry: "8",
    transform: "translate(-55.064516,-55.064516)",
    fill: "#060e2c",
    strokeWidth: "0",
    style: {
      animationName: "ezBt1kfOUiw2__rd, ezBt1kfOUiw2_f_p",
      animationDuration: "3200ms",
      animationFillMode: "forwards",
      animationTimingFunction: "linear",
      animationDirection: "normal",
      animationIterationCount: "infinite"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.690652 0 0 0.690652 41.848704 49.517832)",
    style: {
      animation: "ezBt1kfOUiw3_c_o 3200ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,64v-16h-12L48,0L96,48v16h-12L48,28L12,64Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,52 43,52 56,52 56,68 40,68",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.690652 0 0 0.690652 41.848704 49.517832)",
    opacity: "0",
    style: {
      animation: "ezBt1kfOUiw8_c_o 3200ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,64v-16h-12L48,0L96,48v16h-12L48,28L12,64Z",
    fill: "#0d1f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,52 43,52 56,52 56,68 40,68",
    fill: "#1076bc",
    fillRule: "evenodd"
  })))));
};
NISpinnerSvg.defaultProps = {
  id: "ezBt1kfOUiw1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 150 150",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
};
var TQSpinnerSvg = function TQSpinnerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, "@keyframes eLQuyxkN3qr3_to__to", "{", "0%", "{", "transform:translate(33.75188px,31.5px)", "}", "39.130435%", "{", "transform:translate(33.75188px,31.5px);animation-timing-function:cubic-bezier(0.25,1,0.25,1)", "}", "47.826087%", "{", "transform:translate(33.75188px,43.5px)", "}", "100%", "{", "transform:translate(33.75188px,43.5px)", "}", "}", "@keyframes eLQuyxkN3qr3_c_o", "{", "0%", "{", "opacity:0", "}", "39.130435%", "{", "opacity:0", "}", "47.826087%", "{", "opacity:1", "}", "100%", "{", "opacity:1", "}", "}", "@keyframes eLQuyxkN3qr5_to__to", "{", "0%", "{", "transform:translate(33.5px,19.5px)", "}", "76.086957%", "{", "transform:translate(33.5px,19.5px);animation-timing-function:cubic-bezier(0.25,1,0.25,1)", "}", "91.304348%", "{", "transform:translate(67.5px,29.5px)", "}", "100%", "{", "transform:translate(67.5px,29.5px)", "}", "}", "@keyframes eLQuyxkN3qr5_c_o", "{", "0%", "{", "opacity:1", "}", "76.086957%", "{", "opacity:1", "}", "91.304348%", "{", "opacity:0", "}", "100%", "{", "opacity:0", "}", "}", "@keyframes eLQuyxkN3qr9_to__to", "{", "0%", "{", "transform:translate(50.37594px,19.5px)", "}", "76.086957%", "{", "transform:translate(50.37594px,19.5px);animation-timing-function:cubic-bezier(0.25,1,0.25,1)", "}", "91.304348%", "{", "transform:translate(17.12406px,29.5px)", "}", "100%", "{", "transform:translate(17.12406px,29.5px)", "}", "}", "@keyframes eLQuyxkN3qr9_c_o", "{", "0%", "{", "opacity:1", "}", "76.086957%", "{", "opacity:1", "}", "91.304348%", "{", "opacity:0", "}", "100%", "{", "opacity:0", "}", "}", "@keyframes eLQuyxkN3qr12_to__to", "{", "0%", "{", "transform:translate(33.75188px,19.5px)", "}", "26.086957%", "{", "transform:translate(33.75188px,19.5px);animation-timing-function:cubic-bezier(0.25,1,0.25,1)", "}", "34.782609%", "{", "transform:translate(33.75188px,31.5px)", "}", "65.217391%", "{", "transform:translate(33.75188px,31.5px)", "}", "73.913043%", "{", "transform:translate(33.75188px,43.5px)", "}", "100%", "{", "transform:translate(33.75188px,43.5px)", "}", "}", "@keyframes eLQuyxkN3qr12_c_o", "{", "0%", "{", "opacity:0", "}", "26.304348%", "{", "opacity:0", "}", "35%", "{", "opacity:1", "}", "65.217391%", "{", "opacity:1", "}", "73.913043%", "{", "opacity:0", "}", "100%", "{", "opacity:0", "}", "}", "@keyframes eLQuyxkN3qr15_to__to", "{", "0%", "{", "transform:translate(33.5px,19.5px)", "}", "54.347826%", "{", "transform:translate(33.5px,19.5px)", "}", "63.043478%", "{", "transform:translate(33.5px,31.5px)", "}", "100%", "{", "transform:translate(33.5px,31.5px)", "}", "}", "@keyframes eLQuyxkN3qr15_c_o", "{", "0%", "{", "opacity:1", "}", "54.347826%", "{", "opacity:1", "}", "63.043478%", "{", "opacity:0", "}", "100%", "{", "opacity:0", "}", "}", "@keyframes eLQuyxkN3qr17_to__to", "{", "0%", "{", "transform:translate(67.5px,19.5px);animation-timing-function:cubic-bezier(0.215,0.61,0.355,1)", "}", "10.869565%", "{", "transform:translate(33.5px,19.5px)", "}", "100%", "{", "transform:translate(33.5px,19.5px)", "}", "}", "@keyframes eLQuyxkN3qr20__m", "{", "0%", "{", "d:path('M-0.228336,17.542751L33.75188,39L33.75188,0')", "}", "10.869565%", "{", "d:path('M-0.228336,17.542751L33.75188,39L33.75188,0')", "}", "21.73913%", "{", "d:path('M67,17.542751L33.75188,39L33.75188,0')", "}", "100%", "{", "d:path('M67,17.542751L33.75188,39L33.75188,0')", "}", "}", "@keyframes eLQuyxkN3qr20_c_o", "{", "0%", "{", "opacity:0", "}", "10.869565%", "{", "opacity:0", "}", "21.73913%", "{", "opacity:1", "}", "100%", "{", "opacity:1", "}", "}"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5 8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.75188,31.5)",
    style: {
      animation: "eLQuyxkN3qr3_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.75188,-19.5)",
    opacity: "0",
    style: {
      animation: "eLQuyxkN3qr3_c_o 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#eLQuyxkN3qr6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.5,19.5)",
    style: {
      animation: "eLQuyxkN3qr5_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.75188,0 0,17.542751 33.75188,39 33.75188,17.542751",
    transform: "translate(-33.5,-19.5)",
    fill: "#94bfe7",
    style: {
      animation: "eLQuyxkN3qr5_c_o 4600ms linear infinite normal forwards"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eLQuyxkN3qr6",
    maskType: "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "54.888991",
    rx: "0",
    ry: "0",
    transform: "translate(-6-7.888991)",
    fill: "#fff",
    strokeWidth: "0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#eLQuyxkN3qr10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.37594,19.5)",
    style: {
      animation: "eLQuyxkN3qr9_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "67,17.542751 33.75188,39 33.75188,0",
    transform: "translate(-50.37594,-19.5)",
    fill: "#4594d1",
    style: {
      animation: "eLQuyxkN3qr9_c_o 4600ms linear infinite normal forwards"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eLQuyxkN3qr10",
    maskType: "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "39.74812",
    height: "59.5",
    rx: "0",
    ry: "0",
    transform: "translate(33.75188-9.5)",
    fill: "#fff",
    strokeWidth: "0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.75188,19.5)",
    style: {
      animation: "eLQuyxkN3qr12_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.75188,-19.5)",
    opacity: "0",
    style: {
      animation: "eLQuyxkN3qr12_c_o 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.75188,0 0,17.542751 33.75188,39 67,17.542751",
    fill: "#c9d758"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67,17.542751 33.75188,39 33.75188,0",
    fill: "#bdc549"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.5,19.5)",
    style: {
      animation: "eLQuyxkN3qr15_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.5,-19.5)",
    style: {
      animation: "eLQuyxkN3qr15_c_o 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#eLQuyxkN3qr18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.5,19.5)",
    style: {
      animation: "eLQuyxkN3qr17_to__to 4600ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.75188,0 0,17.542751 33.75188,39 67,17.542751",
    transform: "translate(-33.5,-19.5)",
    fill: "#60b457"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eLQuyxkN3qr18",
    maskType: "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "44.345164",
    rx: "0",
    ry: "0",
    transform: "matrix(1 0 0 1.151502-6.24812 0.000001)",
    fill: "#fff",
    strokeWidth: "0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-0.228336,17.542751L33.75188,39L33.75188,0Z",
    opacity: "0",
    fill: "#48a63e",
    style: {
      animationName: "eLQuyxkN3qr20__m, eLQuyxkN3qr20_c_o",
      animationDuration: "4600ms",
      animationFillMode: "forwards",
      animationTimingFunction: "linear",
      animationDirection: "normal",
      animationIterationCount: "infinite"
    }
  })))));
};
TQSpinnerSvg.defaultProps = {
  id: "eLQuyxkN3qr1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 80 80",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
};
var defaultSizes = {
  sm: '1rem',
  md: '2rem',
  lg: '4.5rem'
};
var TQsizes = {
  sm: '2rem',
  md: '2.75rem',
  lg: '5rem'
};
/**
 * AnimatedSpinner is used to indicate the loading state of a page or a component.
 * It renders an <img src="__.svg" />
 */
export var AnimatedSpinner = forwardRef((props, ref) => {
  var {
      label = 'Loading...',
      className,
      size = 'md',
      svgAttrs
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var {
    tvs,
    isTQ
  } = useThemedValueSwitch();
  var sizes = isTQ ? TQsizes : defaultSizes;
  var _className = cx('tqc-spinner-animated', className);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    w: sizes[size],
    h: sizes[size],
    className: _className,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  }, rest), tvs({
    ni: /*#__PURE__*/React.createElement(NISpinnerSvg, _extends({
      alt: label,
      ref: ref,
      width: sizes[size],
      height: sizes[size]
    }, svgAttrs)),
    tq: /*#__PURE__*/React.createElement(TQSpinnerSvg, _extends({
      alt: label,
      ref: ref,
      width: sizes[size],
      height: sizes[size]
    }, svgAttrs))
  }, /*#__PURE__*/React.createElement(SpinnerSvg, _extends({
    alt: label,
    ref: ref,
    width: sizes[size],
    height: sizes[size]
  }, svgAttrs))));
});